import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useNewAuth } from '../contexts/NewAuthContext';
import Carga from '../view/Common/Carga';

const NewProtectedRoute = ({ children, requiredRoles = [] }) => {
  const { isAuthenticated, isLoading, user } = useNewAuth();
  const location = useLocation();

  // Mostrar loading mientras se verifica la autenticación
  if (isLoading) {
    return (
      <div className="content">
        <Carga />
      </div>
    );
  }

  // Si no está autenticado, redirigir al login
  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Si se requieren roles específicos, verificar usando tip_user
  if (requiredRoles.length > 0) {
    const userTipUser = parseInt(user?.tip_user);
    const hasPermission = requiredRoles.some(role => {
      // Si el rol requerido es un número, comparar directamente con tip_user
      if (typeof role === 'number') {
        return userTipUser === role;
      }
      // Si el rol es string, mapear roles conocidos
      if (role === 'ADMINISTRATOR' || role === 'admin') {
        return userTipUser === 1;
      }
      return false;
    });

    if (!hasPermission) {
      return (
        <div className="content">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-md-6">
                <div className="card mt-5">
                  <div className="card-body text-center">
                    <h3 className="text-danger">Acceso Denegado</h3>
                    <p>No tienes permisos para acceder a esta sección.</p>
                    <p>Tu tipo de usuario: <strong>{user?.tip_user} {userTipUser === 1 ? '(Administrador)' : '(Usuario)'}</strong></p>
                    <p>Permisos requeridos: <strong>{requiredRoles.join(', ')}</strong></p>
                    <button 
                      className="btn btn-primary"
                      onClick={() => window.history.back()}
                    >
                      Volver
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  // Si todo está bien, mostrar el componente protegido
  return children;
};

export default NewProtectedRoute;